module.exports = __webpack_public_path__ + "img/base_activites_artisanat_dart.8351a192.svg";